import RESTSerializer from '@ember-data/serializer/rest';
import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import { underscore } from 'frontend-utils/utils/convert-case';

export default class ApplicationSerializer extends RESTSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  extractMeta(
    store: Store,
    modelClass: ModelSchema,
    payload: Record<string, unknown>,
  ) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    let meta = super.extractMeta(store, modelClass, payload);
    if (!meta) {
      meta = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    meta.payload = payload;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return meta;
  }

  /*
    Responsible for translating api_properties to modelProperties
   */
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  keyForAttribute(attr: string /* , method */) {
    return underscore(attr);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  keyForLink(key: string /* , kind */) {
    return underscore(key);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  keyForRelationship(key: string) {
    return underscore(key);
  }
}
